import { GET_FILTER_LOG, GET_LOG, LogGrid } from "../../../Model/Log"

const initState: LogGrid = {
    LogGridResult: null,
    filter: null,
}
//const dispatch = useDispatch();


export const LogGridReducer = (state = initState, action: { type: string, payload: LogGrid }) => {
    switch (action.type) {
        case GET_LOG:
            {
                return { ...state, LogGridResult: action.payload.LogGridResult }
            }
        case GET_FILTER_LOG:
            return { ...state, filter: action.payload.filter }
        default:
            return state;
    }
}
